import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import Input from '../components/Input/Input';
import Button from '../components/Button/Button';
// import SectionWrapper from '../components/Section/Section';
import Eye from '../assets/images/eye.svg';
import EyeSlash from '../assets/images/eye-slash.svg';
// import DynamicMessage from './popup/DynamicMessage';
import {
  getGwpRandomNumber, setupOnline,
} from '../data-manager/info';

import { doE2E } from '../encryptor/EncryptorOSPL';
import { ArrowRight } from '@/assets/images/arrow';
import {restrictSpecialCharactersForUserId} from '../utils'

const SetupOnlineTrading = ({
  classes,
  restrictSpecialCharacters,
  goToDigitalBankPage,
  goToSystemErrorPage,
  goToOnlineTradingCompletedPage,
  goToHasCompletedPage,
  saveFormData
}) => {
  const dispatch = useDispatch();
  const [formRedux] = useState(
    useSelector((state) => state.form),
  );

  const [onlineTrading, setOnlineTrading] = useState({
    userId: '',
    password: '',
    confirmPassword: '',
  });

  const [pwdErrorText, setPwdErrorText] = useState('');
  const [userIdErrorText, setUserIdErrorText] = useState('');
  const [cpwdErrorText, setcpwdErrorText] = useState('');
  const [typePassword, setTypePassword] = useState('password');
  const [confirmPassword, setConfirmPassword] = useState('password');
  const showPassword = () => (typePassword === 'password' ? setTypePassword('text') : setTypePassword('password'));
  const showConfirmPassword = () => (confirmPassword === 'password' ? setConfirmPassword('text') : setConfirmPassword('password'));
  const [isSubmitting, setIsSubmitting] = useState(false);
  const getOneLineTrading = (name, value, error) => {
    setOnlineTrading({
      ...onlineTrading,
      [name]: value,
    });
    if (name === 'confirmPassword' && value) {
      if (value === onlineTrading.password) {
        setcpwdErrorText('');
      } else {
        setcpwdErrorText('Passwords do not match');
      }
    }
  };

  useEffect(() => {
    setcpwdErrorText(onlineTrading.confirmPassword.length > 0 && onlineTrading.confirmPassword !== onlineTrading.password ? 'Passwords do not match' : '');
  }, [onlineTrading.confirmPassword, onlineTrading.password]);

  const setupOnlineTradingSubmisssion = () => {
    const newFormData = { ...formRedux.form, setupOnlineTrading: true };
    dispatch(saveFormData(newFormData));
    const { caseId, custInfo } = formRedux.form;
    setIsSubmitting(true);
    getGwpRandomNumber(caseId).then(resp => {
      const { randomNo } = resp.data;
      const { userId, password } = onlineTrading;
      if (!resp?.error && randomNo) {
        const frmPwd = { value: password };
        const frmRand = { value: randomNo };
        const frmPStr = {};
        const frmCStr = {};
        let isEncrypted = false;
        const success = doE2E(frmPwd, frmRand, frmPStr, frmCStr, isEncrypted);
        console.log('P_String, C_String, success', frmPStr, frmCStr, success);
        if (success) {
          setupOnline(caseId, userId, frmPStr.value, frmCStr.value).then(osplResp => {
            console.log(osplResp);
            if (osplResp?.data?.errCode) {
              switch (osplResp.data.errCode) {
                case '0':
                  isEncrypted = true;
                  goToOnlineTradingCompletedPage();
                  break;
                case '3':
                case '4':
                  setUserIdErrorText('This username is in use. Try another.');
                  isEncrypted = false;
                  break;
                 default:
                  goToSystemErrorPage();
                 break;
              }

              // if (custInfo.accessCode) {
              //   goToDigitalBankPage();
              // } else {
              //   goToOnlineTradingCompletedPage();
              // }
              // } else if (custInfo.accessCode) {
              //   goToDigitalBankPage();
            } else if (osplResp?.error?.code) {
              goToSystemErrorPage();
            } else {
              goToHasCompletedPage();
            }
          }).catch(()=>{
            goToSystemErrorPage();
          })
          .finally(()=>{
            setIsSubmitting(false);
          })
          ;
        }
      } else if (resp && resp.error && resp.error.code) {
        setIsSubmitting(false);
        switch (resp.error.code) {
          case 'TAM2018':
            goToSystemErrorPage();
            break;
          default:
            // eslint-disable-next-line no-undef
            goToSystemErrorPage();
            break;
        }
      } else {
        setIsSubmitting(false);
      }
      
    }).catch(()=>{
      setIsSubmitting(false);
    });
  };

  return (
    <>
      <div className={classes.setUpHeader}>
        <p className={classes.title}>{formRedux.form && formRedux.form.dynamicContent.setup_ospl_page.TITLE}</p>
        <p className={classes.subTitle}>{formRedux.form && formRedux.form.dynamicContent.setup_ospl_page.CONTENT_TEXT}</p>
      </div>
      <div className={classes.mb40}>
          <Grid container>
            <Grid
              item lg={3} md={4} sm={5} xs={12}
              className={classes.mt40}
            >
              <Input
                label="iOCBC username"
                maxLength={15}
                placeholder=""
                preventSpecialCharacters={restrictSpecialCharactersForUserId}
                value={onlineTrading.userId}
                type="text"
                size="large"
                kind="userID"
                message={formRedux.form && formRedux.form.dynamicContent.setup_ospl_page.USER_ID_TIPS}
                getValue={value => getOneLineTrading('userId', value.value, value.error)}
                errorText={userIdErrorText}
                setErrorText={setUserIdErrorText}
              />
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={3}
              md={4}
              sm={5}
              xs={12}
              className={clsx(classes.mt40, classes.inputWrapper)}
            >
              <Input
                label="Set your password"
                placeholder=""
                maxLength={15}
                value={onlineTrading.password}
                type={typePassword}
                size="large"
                kind="password"
                message={formRedux.form && formRedux.form.dynamicContent.setup_ospl_page.PASSWORD_TIPS}
                paddingRight
                getValue={value => getOneLineTrading('password', value.value, value.error)}
                errorText={pwdErrorText}
                setErrorText={setPwdErrorText}
                inputProps={{
                  endadornment: null,
                  type: typePassword,
                  maxLength: 15
                }}
              />
              <div
                className={classes.icon}
                onClick={() => showPassword()}
                aria-hidden="true"
              >
                <img
                  className={classes.eyeIcon}
                  src={typePassword === 'password' ? EyeSlash : Eye}
                  alt="eye"
                />
              </div>
            </Grid>
            <Grid item lg={1} md={1} sm={1} xs={12} className={classes.empty} />
            <Grid
              item
              lg={3}
              md={4}
              sm={5}
              xs={12}
              className={clsx(classes.mt40, classes.inputWrapper)}
            >
              <Input
                label="Confirm password"
                placeholder=""
                value={onlineTrading.confirmPassword}
                type={confirmPassword}
                size="large"
                kind="confirmPassword"
                paddingRight
                errorText={cpwdErrorText}
                setErrorText={setcpwdErrorText}
                getValue={value => getOneLineTrading('confirmPassword', value.value, value.error)}
                inputProps={{
                  endadornment: null,
                  type: confirmPassword
                }}
              />
              <div
                className={classes.icon}
                onClick={() => showConfirmPassword()}
                aria-hidden="true"
              >
                <img
                  className={classes.eyeIcon}
                  src={confirmPassword === 'password' ? EyeSlash : Eye}
                  alt="eye"
                />
              </div>
              {/* {onlineTrading.confirmPassword.length > 0 && onlineTrading.confirmPassword !== onlineTrading.password && (
                <div className={clsx(classes.message, classes.mt5)}>
                  Passwords do not match
                </div>
              )} */}
            </Grid>
          </Grid>
      </div>
      <div className={classes.buttonWrapper}>
        <Button
          backgroundClass="bgLipstickOrangey" onClick={() => setupOnlineTradingSubmisssion()}
          disabled={!(onlineTrading.userId && onlineTrading.password && onlineTrading.confirmPassword) || userIdErrorText || pwdErrorText || cpwdErrorText || isSubmitting}
        >
          Submit
          <ArrowRight size="24" color="currentColor" />
        </Button>
      </div>
    </>
  );
};

export default SetupOnlineTrading;